import styled from '@emotion/styled';

import { pageSectionLayout } from '@/styles/pageLayout';

export const HistoryContainer = styled.section`
	${pageSectionLayout}
	--history-sticky-top: calc(
		${(props) => props.theme.heights.header} + ${(props) => props.theme.heights.pageTabBar}
	);
	--history-period-bar-height: ${(props) => props.theme.heights.historyPeriodBar};
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;

	@media screen and (max-width: 1180px) {
		--history-sticky-top: ${(props) => props.theme.heights.headerMobile};
	}
`;

/** 헤더·페이지 탭 아래에 고정되는 전체 너비 바 */
export const HistoryStickyBar = styled.div`
	position: sticky;
	top: var(--history-sticky-top, ${(props) => props.theme.heights.headerMobile});
	z-index: 8;
	width: 100vw;
	margin-left: calc(50% - 50vw);
	margin-right: calc(50% - 50vw);
	background-color: #fff;
	border-bottom: 1px solid #dee2e6;
	box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.06);
`;

export const HistoryDateList = styled.div`
	display: flex;
	width: 100%;
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	height: var(--history-period-bar-height, 5.2rem);
	margin: 0 auto;
	overflow-x: auto;
	white-space: nowrap;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const HistoryDate = styled.button`
	flex: 1 1 0;
	min-width: 9rem;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	background-color: #f1f3f5;
	border: none;
	border-left: 1px solid #dee2e6;
	cursor: pointer;
	font-family: inherit;

	@media screen and (min-width: 901px) {
		min-width: 12rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
	}

	&.active {
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
	}

	&:first-of-type {
		border-left: none;
	}
`;

export const HistoryContents = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6rem;
	width: 100%;
	padding-top: 4rem;

	@media screen and (max-width: 900px) {
		gap: 4rem;
		padding-top: 3rem;
	}
`;

export const HistoryContentWrapper = styled.article`
	display: flex;
	gap: 3.2rem;
	width: 100%;
	scroll-margin-top: calc(var(--history-sticky-top) + var(--history-period-bar-height) + 1.6rem);

	@media screen and (max-width: 900px) {
		flex-direction: column;
		gap: 2rem;
		scroll-margin-top: calc(var(--history-sticky-top) + var(--history-period-bar-height) + 1.2rem);
	}
`;

export const HistoryImgBox = styled.article<{ bgImg: string }>`
	flex-shrink: 0;
	max-width: 40rem;
	width: 100%;
	height: 28rem;
	background-image: url(${(props) => props.bgImg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: ${(props) => props.theme.effects.radiusMd};

	@media screen and (max-width: 900px) {
		max-width: none;
		height: 20rem;
	}
`;

export const HistoryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	width: 100%;
	min-width: 0;

	@media screen and (max-width: 900px) {
		gap: 2.4rem;
	}
`;

export const HistoryContentMainTitle = styled.h2`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.size6xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: ${(props) => props.theme.colors.primary400};
	padding: 2rem 0;
	border-bottom: 1px solid #adb5bd;

	@media screen and (max-width: 900px) {
		font-size: ${(props) => props.theme.fontSize.size3xl};
		padding: 1.2rem 0;
	}
`;

export const HistoryContentTitle = styled.h3`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;

	@media screen and (max-width: 900px) {
		font-size: ${(props) => props.theme.fontSize.size2xl};
	}
`;

export const HistoryContentItemBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
`;

export const HistoryContentItem = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	margin: 0;
	padding: 0;
	list-style: none;
`;

export const HistoryContentSubTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;

	@media screen and (max-width: 900px) {
		font-size: ${(props) => props.theme.fontSize.sizeMd};
	}
`;

export const HistoryContentDescription = styled.li`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	position: relative;
	padding-left: 0.8rem;
	word-break: keep-all;
	overflow-wrap: break-word;

	@media screen and (max-width: 900px) {
		font-size: ${(props) => props.theme.fontSize.sizeMd};
	}

	&::after {
		content: '';
		position: absolute;
		top: calc(0.8em - 3px);
		left: 0;
		background-color: currentColor;
		width: 4px;
		height: 4px;
		border-radius: 50%;
	}
`;
